// extracted by mini-css-extract-plugin
export default {"ctn":"Ancor_ctn_p7XmD"};